import { publicIdSchema } from "@rosc/contracts";
import { z } from "zod";

export function checkPublicPage<T extends { public_id: string }>(
  page: { items: T[]; nextCursor: string | null },
  cursor?: string,
  seen = new Set<string>(),
): typeof page {
  if (page.items.length > 100) throw Error("Page exceeds requested bound");
  for (const item of page.items) {
    if (item.public_id === cursor || seen.has(item.public_id))
      throw Error("Invalid pagination progress. Restart this list.");
    seen.add(item.public_id);
  }
  if (
    page.nextCursor !== null &&
    (!page.items.length || page.nextCursor !== page.items.at(-1)?.public_id)
  )
    throw Error("Invalid pagination cursor. Restart this list.");
  return page;
}

const traversalSchema = z.array(
  z.object({
    items: z.array(z.object({ public_id: publicIdSchema })),
    nextCursor: publicIdSchema.nullable(),
  }),
);
export function publicTraversalError(pages: unknown): boolean {
  if (pages === undefined) return false;
  const parsed = traversalSchema.safeParse(pages);
  if (!parsed.success) return true;
  const seen = new Set<string>();
  let cursor: string | undefined;
  try {
    for (const [index, page] of parsed.data.entries()) {
      if (index > 0 && cursor === undefined) return true;
      checkPublicPage(page, cursor, seen);
      cursor = page.nextCursor ?? undefined;
    }
    return false;
  } catch {
    return true;
  }
}
